import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  constructor(private httpClient: HttpClient) { }

  public delete(partnerId: number): Observable<any> {
    return this.httpClient.delete(`/api/partners/${partnerId}`);
  }

  public files(partnerId: number): Observable<any> {
    return this.httpClient.get(`/api/partners/${partnerId}/files`);
  }

  public get(partnerId: number): Observable<any> {
    return this.httpClient.get(`/api/partners/${partnerId}`);
  }
  
  public recent(): Observable<any> {
    return this.httpClient.get('/api/partners/recent');
  }

  public save(partnerId: number, data: object): Observable<any> {
    return this.httpClient.post(`/api/partners/${partnerId ? partnerId : ''}`, data);
  }  
  
  public search(params: {}): Observable<any> {
    return this.httpClient.get('/api/partners', { params: new HttpParams({ fromObject: params }) });
  }

  public grant(customerId: number, partnerId: number): Observable<any> {
    return this.httpClient.post(`/api/customers/${customerId}/partner-mappings`, { partner: partnerId });
  }

  public revoke(customerId: number, partnerId: number): Observable<any> {
    return this.httpClient.delete(`/api/customers/${customerId}/partner-mappings/${partnerId}`);
  }
}
